import { render, staticRenderFns } from "./data57.vue?vue&type=template&id=b0b9fdb4&scoped=true&"
import script from "./data57.vue?vue&type=script&lang=js&"
export * from "./data57.vue?vue&type=script&lang=js&"
import style1 from "./data57.vue?vue&type=style&index=1&id=b0b9fdb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b9fdb4",
  null
  
)

export default component.exports